// extracted by mini-css-extract-plugin
export default {"Panel__SideBar":"EtlDesigner_Panel__SideBar__KJyIo","ApplicationContent":"EtlDesigner_ApplicationContent__LZLCz","CanvasContainer":"EtlDesigner_CanvasContainer__vnwkP"};